"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockedInit = void 0;
var GlobalStore_1 = require("../store/GlobalStore");
var closeWindow_1 = require("./closeWindow");
var getAccessToken_1 = require("./getAccessToken");
var getAId_1 = require("./getAId");
var getContext_1 = require("./getContext");
var getDecodedIDToken_1 = require("./getDecodedIDToken");
var getFriendship_1 = require("./getFriendship");
var getIDToken_1 = require("./getIDToken");
var getIsVideoAutoPlay_1 = require("./getIsVideoAutoPlay");
var getLanguage_1 = require("./getLanguage");
var getLineVersion_1 = require("./getLineVersion");
var getOS_1 = require("./getOS");
var getProfile_1 = require("./getProfile");
var getProfilePlus_1 = require("./getProfilePlus");
var getVersion_1 = require("./getVersion");
var initPlugins_1 = require("./initPlugins");
var isApiAvailable_1 = require("./isApiAvailable");
var isInClient_1 = require("./isInClient");
var isLoggedIn_1 = require("./isLoggedIn");
var isSubWindow_1 = require("./isSubWindow");
var login_1 = require("./login");
var logout_1 = require("./logout");
var openWindow_1 = require("./openWindow");
var permanentLink_createUrl_1 = require("./permanentLink_createUrl");
var permanentLink_createUrlBy_1 = require("./permanentLink_createUrlBy");
var permanentLink_setExtraQueryParam_1 = require("./permanentLink_setExtraQueryParam");
var permission_1 = require("./permission");
var scanCode_1 = require("./scanCode");
var sendMessages_1 = require("./sendMessages");
var shareTargetPicker_1 = require("./shareTargetPicker");
var subWindow_1 = require("./subWindow");
var _addListener_1 = require("./_addListener");
var _call_1 = require("./_call");
var _dispatchEvent_1 = require("./_dispatchEvent");
var _postMessage_1 = require("./_postMessage");
var _removeListener_1 = require("./_removeListener");
var createMockedInit = function (injectLiffMock, isCalledInLiffBrowser) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var init = function (config, successCallback, errorCallback) {
        if (!GlobalStore_1.globalStore.isInitCalled) {
            injectLiffMock({
                getLanguage: getLanguage_1.getLanguage,
                getOS: getOS_1.getOS,
                getVersion: getVersion_1.getVersion,
                getLineVersion: getLineVersion_1.getLineVersion,
                isApiAvailable: isApiAvailable_1.isApiAvailable,
                isInClient: isInClient_1.isInClient,
                isLoggedIn: isLoggedIn_1.isLoggedIn,
                login: login_1.login,
                logout: logout_1.logout,
                getAccessToken: getAccessToken_1.getAccessToken,
                getIDToken: getIDToken_1.getIDToken,
                getDecodedIDToken: getDecodedIDToken_1.getDecodedIDToken,
                getContext: getContext_1.getContext,
                getProfile: getProfile_1.getProfile,
                getFriendship: getFriendship_1.getFriendship,
                permanentLink: {
                    createUrl: permanentLink_createUrl_1.permanentLink_createUrl,
                    createUrlBy: permanentLink_createUrlBy_1.permanentLink_createUrlBy,
                    setExtraQueryParam: permanentLink_setExtraQueryParam_1.permanentLink_setExtraQueryParam,
                },
                sendMessages: sendMessages_1.sendMessages,
                openWindow: openWindow_1.openWindow,
                shareTargetPicker: shareTargetPicker_1.shareTargetPicker,
                scanCode: scanCode_1.scanCode,
                scanCodeV2: scanCode_1.scanCode,
                closeWindow: closeWindow_1.closeWindow,
                initPlugins: initPlugins_1.initPlugins,
                // private
                getAId: getAId_1.getAId,
                getProfilePlus: getProfilePlus_1.getProfilePlus,
                getIsVideoAutoPlay: getIsVideoAutoPlay_1.getIsVideoAutoPlay,
                subWindow: subWindow_1.subWindow,
                isSubWindow: isSubWindow_1.isSubWindow,
                permission: permission_1.permission,
                _dispatchEvent: _dispatchEvent_1._dispatchEvent,
                _call: _call_1._call,
                _addListener: _addListener_1._addListener,
                _removeListener: _removeListener_1._removeListener,
                _postMessage: _postMessage_1._postMessage,
            });
        }
        GlobalStore_1.globalStore.initIsCalled();
        // Login automatically if LIFF app is running in LIFF browser
        // https://developers.line.biz/en/reference/liff/#login
        if (isCalledInLiffBrowser && GlobalStore_1.globalStore.numberOfLoginCalled === 0) {
            (0, login_1.login)();
        }
        if (typeof successCallback === 'function') {
            successCallback();
        }
        return Promise.resolve();
    };
    return init;
};
exports.createMockedInit = createMockedInit;
